import PropTypes from 'prop-types';

const defaultProps = {};

const propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default function EventCategories({
  categories,
}) {
  return (
    <div className="flex items-center space-x-4">
      {categories.map(({ id, name }) => (
        <div key={id} className="text-gray-900 leading-none whitespace-nowrap">
          {name}
        </div>
      ))}
    </div>
  );
}

EventCategories.defaultProps = defaultProps;
EventCategories.propTypes = propTypes;
